import { useCallback } from 'react'
import { useCookies } from 'react-cookie'
import { ONE_DAY_IN_SECONDS } from '../../../apps/professional-app/fa/common/aifeatures/utils'
import { useAppSelector } from '../../../store/hooks'
import { selectSafeAuthenticatedUser } from '../../../store/auth/authSlice'
import { TrackEvent, useTracking } from '../../../apps/professional-app/fa/common/tracking'

const HIDE_INSIGHTS_FEEDBACK_CTA_COOKIE_MAX_AGE = ONE_DAY_IN_SECONDS * 14

const getTypeformUrl = (userId: string, email: string) => {
  const encodedEmail = encodeURIComponent(email)
  const encodedUserId = encodeURIComponent(userId)
  return `https://ljn4s9vaxf9.typeform.com/to/ge6j4Y3E#email=${encodedEmail}&user_id=${encodedUserId}`
}

export const useInsightsFeedback = () => {
  const [cookies, setCookie] = useCookies(['hideInsightsFeedbackCTA'])
  const { id, email } = useAppSelector(selectSafeAuthenticatedUser)
  const { trackingClient } = useTracking()

  const handleDismiss = useCallback(() => {
    setCookie('hideInsightsFeedbackCTA', true, { path: '/', maxAge: HIDE_INSIGHTS_FEEDBACK_CTA_COOKIE_MAX_AGE })
    trackingClient.track({ eventName: TrackEvent.INSIGHTS_FEEDBACK_DISMISSED })
  }, [setCookie, trackingClient])

  const handleFeedbackClick = useCallback(() => {
    trackingClient.track({ eventName: TrackEvent.INSIGHTS_FEEDBACK_OPENED })
  }, [trackingClient])

  const navigateTo = getTypeformUrl(id, email)

  const hasHiddenInsightsFeedbackCTACookie = cookies.hideInsightsFeedbackCTA === true || cookies.hideInsightsFeedbackCTA === 'true'
  const shouldShowInsightsFeedbackCTA = !hasHiddenInsightsFeedbackCTACookie

  return {
    navigateTo,
    handleDismiss,
    handleFeedbackClick,
    shouldShowInsightsFeedbackCTA,
  }
}
